// The upgrade guide is rendered before a device dashboard is fully available.
// Keep these presentation assets local instead of depending on environment
// variables, otherwise the modal falls back to empty placeholders when an
// icon variable is absent from a deployment environment.
const icon = (name, file) => ({
  name,
  img: file.startsWith('/') ? file : `/images/dashboard/new-ios/${file}`
})

export const EXTREME_UPGRADE_GROUPS = [
  {
    titleKey: 'Messages & Calls',
    items: [
      icon('Text Messages', 'imessagers.png'),
      icon('Calls', 'calls.svg'),
      icon('Voicemail', 'voicemail.svg'),
      icon('FaceTime', 'facetime.svg')
    ]
  },
  {
    titleKey: 'Social & Chat',
    items: [
      icon('WhatsApp', 'whatsapp.svg'),
      icon('WA Business', 'whatappbusiness.svg'),
      icon('LINE', 'line.svg'),
      icon('Kik', 'kik.svg'),
      icon('WeChat', 'wechat.svg'),
      icon('Teams', 'teams.svg'),
      icon('Messenger', 'facebookmessage.svg'),
      icon('Telegram', 'telegram.svg'),
      icon('Snapchat', 'snapchat.svg'),
      icon('Instagram', 'instagram.svg'),
      icon('Skype', 'skype.svg')
    ]
  },
  {
    titleKey: 'System & Web',
    items: [
      icon('Browser History', 'browsing.png'),
      icon('Browser Bookmarks', 'bookmark.svg'),
      icon('Installed Apps', 'installed-app.svg'),
      icon('Wi-Fi Networks', 'wifi.svg')
    ]
  }
]

export const EXTREME_UPGRADE_FLAT_ICONS = EXTREME_UPGRADE_GROUPS.flatMap(group => group.items)
